import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SafeIcon from '../../common/SafeIcon';

const Industries = () => {
  const { FiHome, FiBriefcase, FiCoffee, FiHeart, FiTool, FiCloud } = FiIcons;

  useSEO({
    title: 'NYC Industries We Serve | Specialized SEO Agency',
    description: 'Specialized SEO strategies for NYC Restaurants, Law Firms, Medical Practices, Contractors, Real Estate, and SaaS companies.',
  });

  const industries = [
    { title: "SEO for Real Estate in NYC", icon: FiHome, desc: "Hyper-competitive brokerages need extreme local visibility. We optimize property listings, build neighborhood guides, and capture high-intent buyer/renter search traffic." },
    { title: "SEO for Law Firms in NYC", icon: FiBriefcase, desc: "Personal injury, corporate, and criminal defense law in NYC requires massive E-E-A-T. We build unshakeable authority and dominate localized legal search terms." },
    { title: "SEO for Restaurants in NYC", icon: FiCoffee, desc: "Outrank aggregator sites like Yelp. We focus on Local Map Pack dominance, visual search optimization, and review schema to drive foot traffic and reservations." },
    { title: "SEO for Medical Practices", icon: FiHeart, desc: "Patient acquisition requires trust. We optimize for 'near me' healthcare searches, ensuring YMYL compliance and authority." },
    { title: "SEO for Contractors in NYC", icon: FiTool, desc: "Plumbers, electricians, and builders need emergency visibility. We structure your site to capture high-converting local search traffic." },
    { title: "SEO for Startups & SaaS", icon: FiCloud, desc: "NYC tech companies need national and global reach. We deploy programmatic SEO and thought-leadership content to scale organic acquisition." }
  ];

  return (
    <div className="pt-20 pb-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Specialized Expertise" 
            title="Industry-Specific SEO Mastery" 
            description="We don't use cookie-cutter strategies. Every industry in New York City has unique search patterns and competitive landscapes."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {industries.map((ind, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <div className="bg-slate-950 border border-slate-800 p-8 rounded-xl h-full shadow-lg">
                <div className="w-12 h-12 bg-blue-900/50 rounded-full flex items-center justify-center mb-6">
                  <SafeIcon icon={ind.icon} className="text-2xl text-blue-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{ind.title}</h3>
                <p className="text-slate-400 leading-relaxed text-sm">{ind.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;